// ─────────────────────────────────────────────────────────────────
// Glass-i — Employee Transfers API client (Stage HRMS-3).
// ─────────────────────────────────────────────────────────────────

import client from '../../../../api/client';

const BASE = '/api/erp/hrms/employee-transfers';
const enc = encodeURIComponent;

function unwrap(resp) {
  return resp && resp.data && resp.data.data !== undefined ? resp.data.data : resp && resp.data;
}

export const hrTransfersApi = {
  list:    (params = {}) => client.get(BASE, { params }).then(unwrap),
  get:     (id)          => client.get(`${BASE}/${enc(id)}`).then(unwrap),
  create:  (payload)     => client.post(BASE, payload).then(unwrap),
  update:  (id, payload) => client.put(`${BASE}/${enc(id)}`, payload).then(unwrap),
  remove:  (id)          => client.delete(`${BASE}/${enc(id)}`).then(unwrap),
  approve: (id, payload = {}) => client.post(`${BASE}/${enc(id)}/approve`, payload).then(unwrap),
  cancel:  (id)          => client.post(`${BASE}/${enc(id)}/cancel`, {}).then(unwrap)
};

export default hrTransfersApi;
